export function formatDateTime(dateTime) {
    let dtFormatted = new Intl.DateTimeFormat('en-US', { 
      year: 'numeric', 
      month: 'short', 
      day: '2-digit', 
      hour: '2-digit', 
      minute: '2-digit' 
    }).format(dateTime);

    return dtFormatted;
}